export const learnMoreChallengeCards = [
    {
        title: '',
        subTitle: '',
        imageURL: ''
    },
    {
        title: 'Fit For All Levels',
        subTitle:
            'These fitness challenges are designed to make exercising fun, no matter where you are on your journey. Regardless if you’re a beginner, intermediate, or advanced athlete, there is a challenge that is right for YOU!',
        imageURL: 'https://asset.yes.fit/homepage/lm-challenges-01.png'
    },
    {
        title: 'On Your Schedule',
        subTitle:
            'Commit to getting fit on your own time. With challenges ranging from 1 to 45 days, we make it easy to find something that fits into your busy lifestyle. Complete each fitness event at your own pace and reward yourself for your accomplishments!',
        imageURL: 'https://asset.yes.fit/homepage/lm-challenges-02.png'
    },
    {
        title: 'Push Yourself',
        subTitle:
            'The biggest growth happens when you challenge yourself. Try something new, commit to your health, and get rolling with one of our free fitness challenges today or <a class="underline text-yf-green" href="/membership">become a VIP Member</a> and unlock the whole library. A healthier you is waiting!',
        imageURL: 'https://asset.yes.fit/homepage/Learn-More-Challenge.gif'
    }
]
